import {Mental2SymbolStates} from "../enums/Enum";
import {Symbol} from "./Symbol";
import {GameAssets} from "../GameAssets";
import {BitMapMultiplier} from "../components/BitmapMultiplier";

export class NudgeSymbol extends Symbol {
    private _multiplier: BitMapMultiplier;

    constructor(symbolName: string, initState: Mental2SymbolStates, index: number, isActive: boolean = false) {
        super(symbolName, initState, index);
        this.pivot.set(0, -248);
        this._multiplier = new BitMapMultiplier(GameAssets.BITMAP_FONT_X_NUDGE_WIN_COUNT_UP, 28, "x");
        this._multiplier.anchor = new PIXI.Point(0.5, 0.5);
        this._multiplier.position.set(0, -75);
        this.addChild(this._multiplier);
    }

    public setPivot(reelId: number): void {
        this.setNoWinToNormalState(reelId);
        this.pivot.set(0, reelId === 2 ? -248 : -200);
    }

    init(symbolName: string, initState: Mental2SymbolStates, index: number) {
        super.init(symbolName, initState, index);
    }

    public playEnhancerReveal(): void { //used in symbol container

    }

    public setNoWinState(reelId: number) {
        const animName: string = reelId === 2 ? "Nowin" : "Nowin_half";
        this.state.setAnimation(0, animName, false);
        this._multiplier.tint = 0x777676;
        this.autoUpdate = true;
    }

    public setNoWinToNormalState(reelId: number) {
        const animName: string = reelId === 2 ? "Nowin_to_normal" : "Nowin_to_normal_half";
        this.state.setAnimation(0, animName, false);
        this._multiplier.tint = 0xffffff;
        this.autoUpdate = true;
    }

    public setResizeState(animName: string): PIXI.spine.core.TrackEntry {
        return this.state.tracks[0];
    }

    public updateFinalMultiplier(value: number): void {
        this._multiplier.value = value;
    }

    public multiplyMultiplier(value: number): void {
        this._multiplier.value *= value;
    }

    public removeSymbol(): void {
        super.removeSymbol();
        this._multiplier.value = 1;
    }

    public updateMultiplier(value: number): void {
        this._multiplier.add(value);
    }

}